import * as React from "react";
import { PureComponent } from "react";
import { Marker } from "react-leaflet";
import L from "leaflet";
import AppContext from "../../context/AppContext";

class MapAirport extends PureComponent<any> {
  static contextType = AppContext;

  handleClick = () => {
    const { showInfoWindow } = this.context;
    const { airport } = this.props;
    showInfoWindow("airport", airport.id);
  };

  render() {
    const { airport } = this.props;
    const icon = L.icon({
      iconUrl: "./icons/airport.svg",
      iconSize: [24, 24],
      iconAnchor: [12, 24]
    });
    return (
      <Marker
        position={[airport.lat, airport.lon]}
        icon={icon}
        title={airport.name}
        zIndexOffset={1000}
        onClick={this.handleClick}
      />
    );
  }
}

export default MapAirport;
